interface QueryDefinition {
  kind: 'OperationDefinition' | 'FragmentDefinition';
  operation: 'query' | 'mutation' | 'subscription';
  name: {
    kind: 'Name';
    value: string;
  } | null;
}

export interface QueryType {
  definitions: QueryDefinition[];
}

/** Pass in getQueryName(SamplePage.query), and this will return a string name that can be put in refetchQueries */
export const getQueryName = (query: QueryType): string => {
  const operationDefinition = query.definitions?.find(
    (definition) => definition.kind === 'OperationDefinition',
  );
  //   If name isn't found, then there's a broken link and we want to alert that something is wrong
  if (!operationDefinition || !operationDefinition.name?.value) {
    throw new Error('No query name found');
  }
  return operationDefinition.name.value;
};
